import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { createRequestOption } from '../model/request.utils';



@Injectable({
  providedIn: 'root'
})
export class UserService {
  private resourceUrl = 'api/users';

  constructor(private http: HttpClient) {
  }

  create(user: App.User): Observable<any> {
    return this.http.post(this.resourceUrl, user);
  }

  update(user: App.User): Observable<any> {
    return this.http.put(this.resourceUrl, user);
  }

  delete(id: App.ParamID): Observable<any> {
    return this.http.delete(`${this.resourceUrl}/${id}`);
  }

  find(login: string): Observable<App.User> {
    return this.http.get<App.User>(`${this.resourceUrl}/${encodeURIComponent(login)}`);
  }

  query(req?: any): Observable<HttpResponse<App.User[]>> {
    const params = createRequestOption(req);

    return this.http.get<App.User[]>(this.resourceUrl, {
      params,
      observe: 'response'
    });
  }

  sendActivation(login: string): Observable<any> {
    return this.http.post('api/account/reset-activation/init', login);
  }

  findByProjectAndAuthority(req: any): Observable<App.User[]> {
    const params = createRequestOption(req);
    return this.http.get<App.User[]>(this.resourceUrl, { params });
  }

  getFullname(value: App.User): string {
    if (!value) {
      return $localize`:@@global.label.unknown:Unknown`;
    } else if (!value.firstName && !value.lastName) {
      return value.email;
    }
    return `${value.firstName} ${value.lastName}`;
  }
}
